// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles__imageContainer___SyR_w","image":"styles__image___TTcJa","text":"styles__text___aJxAv"};